<template>
  <div class="white">
    <header-guideline />
    <v-flex xs12 class="bluePurple py-3 px-4 sticky-header">
      <v-row class="px-10">
        <v-breadcrumbs
          class="px-0 subtitle-2 mt-0 pt-0 pb-1 breadcrumbs-items white--text"
          :items="breadcrumbs"
        ></v-breadcrumbs>
        <v-spacer></v-spacer>
        <a class="white--text fs-14" @click="homePage">Back to Home page</a>
      </v-row>
    </v-flex>
    <v-flex xs12 class="py-5 px-3">
      <v-row class="pl-8 pr-0" justify="space-between">
        <v-col cols="6" class="d-flex px-0">
          <v-scroll-y-transition mode="out-in">
            <v-col cols="12">
              <v-card class="pt-0 px-0" flat>
                <v-card-text class="pt-0 px-0">
                  <h2 class="bluePurple--text mb-0 pb-0">
                    Contact Support
                  </h2>
                  <v-col cols="12" class="px-0 py-6">
                    <v-text-field
                      :rules="[nameRules.required]"
                      v-model="name"
                      placeholder="Name"
                      outlined
                      rounded
                      required
                      dense
                    ></v-text-field>
                    <v-text-field
                      :rules="[emailRules.required]"
                      v-model="email"
                      placeholder="Email"
                      outlined
                      type="email"
                      rounded
                      required
                      dense
                    ></v-text-field>
                    <v-text-field
                      :rules="[subjectRules.required]"
                      v-model="subject"
                      placeholder="Subject"
                      outlined
                      rounded
                      required
                      dense
                    ></v-text-field>
                    <v-textarea
                      :rules="[messageRules.required]"
                      v-model="description"
                      placeholder="Message"
                      outlined
                      rounded
                      rows="4"
                      required
                      dense
                      class="rounded-15"
                    ></v-textarea>
                    <v-col cols="12" class="pa-0 text-right">
                      <!-- <vue-recaptcha
                        sitekey="6LcXP-EZAAAAANpFdPN-vUmb68w6BHKmLzXlVF1U"
                        @verify="onCaptchaVerified"
                        @expired="onCaptchaExpired"
                        :loadRecaptchaScript="true"
                      >
                      </vue-recaptcha> -->
                      <div class="captcha">
                        <v-checkbox
                          v-model="captcha"
                          label="I'm not a robot"
                          class="captcha-box"
                        ></v-checkbox>
                      </div>
                      <v-btn
                        @click="send()"
                        color="menuActive"
                        :loading="loading"
                        small
                        :disabled="!isDisabled"
                        class="text-capitalize px-8 py-4 fs-14 font-weight-bold rounded-24 mt-4 white--text"
                      >
                        Submit
                      </v-btn>
                    </v-col>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-col>
          </v-scroll-y-transition>
        </v-col>
        <v-col cols="6" class="px-0 py-5 text-right">
          <img src="@/assets/images/support.svg" width="85%" />
        </v-col>
      </v-row>
    </v-flex>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import headerGuideline from '../../../components/contentManagement/header';
import ProgressDialog from '../../../components/progress_dialog';
// import VueRecaptcha from 'vue-recaptcha';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    'header-guideline': headerGuideline
    // VueRecaptcha
  },
  data() {
    return {
      captcha: false,
      scrollSettings: {
        maxScrollbarLength: 60
      },
      progressDialogLoading: false,
      loading: false,
      nameRules: {
        required: value => !!value || 'Name is required.'
      },
      emailRules: {
        required: value => !!value || 'Email is required.'
      },
      subjectRules: {
        required: value => !!value || 'Subject is required.'
      },
      messageRules: {
        required: value => !!value || 'Message is required.'
      },
      active: [],
      open: [],
      tree: [],
      breadcrumbs: [
        {
          text: 'Help Center'
          // disabled: true,
          // href: '#'
        },
        {
          text: 'Contact Support'
        }
      ],
      items: [],
      isCaptchaVerified: false,
      name: '',
      email: '',
      subject: '',
      description: ''
    };
  },
  computed: {
    isDisabled() {
      if (
        this.name &&
        this.email &&
        this.subject &&
        this.description &&
        this.captcha
      )
        return true;
      return false;
    }
  },
  methods: {
    onCaptchaVerified() {
      this.isCaptchaVerified = true;
    },
    onCaptchaExpired(e) {
      console.log(e);
    },
    send() {
      this.loading = true;
      let body = {
        name: this.name,
        email: this.email,
        subject: this.subject,
        description: this.description
      };
      this.$store
        .dispatch('support/sendEmail', body)
        .then(data => {
          if (data.code === 200) {
            this.loading = false;
            this.name = '';
            this.email = '';
            this.subject = '';
            this.description = '';
            Swal.fire('Success!', data.message.text_en, 'success');
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    homePage() {
      this.$router.push({
        name: 'content-management'
      });
    }
  }
};
</script>
<style>
.image-icon {
  opacity: 0.1;
  position: absolute;
  top: 12%;
  right: -7%;
  height: 60%;
}
.drawer-menu--scroll-guideline {
  max-height: 380px;
  overflow: auto;
}
.drawer-menu--scroll-guideline-menu {
  max-height: 450px;
  overflow: auto;
}
@media (min-height: 768px) {
  .drawer-menu--scroll-guideline {
    max-height: 500px !important;
    overflow: auto;
  }
  .drawer-menu--scroll-guideline-menu {
    max-height: 570px !important;
    overflow: auto;
  }
}
</style>
